import React from 'react'
import "./footer.style.css"

export const Footer = () => {
    return (
        <footer className="footer">
            Made with ❤ by Priyansh
        </footer>
    )
}
